import React from 'react';
import { Link } from 'react-router-dom';
import salientLogo from '../../assets/images/logos/salient_logo.png';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            {/* <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-salient-secondary to-white bg-clip-text text-transparent">
              Salient
            </h3> */}
            <img src={salientLogo} alt="Salient Logo" className="h-16 mb-4"/>
            <p className="text-gray-300">
              Soluciones integrales para tu negocio que combinan tecnología, estrategia y energía.
            </p>
          </div>
          {/* <div>
            <h4 className="text-lg font-medium mb-4">Tecnología</h4>
            <ul className="space-y-2">
              <li><Link to="/tech/network-infrastructure" className="text-gray-300 hover:text-white">Infraestructura de red</Link></li>
              <li><Link to="/tech/software-consulting" className="text-gray-300 hover:text-white">Consultoría en software</Link></li>
            </ul>
          </div> */}
          <div>
            <h4 className="text-lg font-medium mb-4">Servicios</h4>
            <ul className="space-y-2">
              {/* <li><Link to="/" className="text-gray-300 hover:text-white">Soluciones Empresariales</Link></li> */}
              <li><a href="/#marketing-strategic-section" className="text-gray-300 hover:text-white">Marketing Estratégico</a></li>
              {/* <li><Link to="/mkt/sales" className="text-gray-300 hover:text-white">Ventas</Link></li> */}
              {/* <li><Link to="/energy/clean-energy" className="text-gray-300 hover:text-white">Energías limpias</Link></li>
              <li><Link to="/energy/electrical-projects" className="text-gray-300 hover:text-white">Proyectos eléctricos</Link></li> */}
            </ul>
          </div>
          <div>
            <h4 className="text-lg font-medium mb-4">Contacto</h4>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2">
                <i className="fa fa-envelope text-xl hover:text-blue-500"></i>                
                <a href="mailto:salient.mkt@gmail.com" className="text-gray-300 hover:text-white"><span>salient.mkt@gmail.com</span></a>
              </li>
              <li className="flex items-center space-x-2">
                <i className="fa fa-phone text-xl hover:text-blue-500"></i>
                <a href="tel:+524423424429" className="text-gray-300 hover:text-white"><span>+52 442 342 4429</span></a>
              </li>
              {/* <li className="flex items-center space-x-2">
                <i className="fa fa-map-marker text-xl hover:text-blue-500"></i>
                <span>Ciudad de México, México</span>
              </li> */}
              <li className="mt-4">
                <Link to="/about-us" className="text-gray-300 hover:text-white">Quienes somos</Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white">Contáctanos</Link>
              </li>
              <li>
                <Link to="/politica-de-privacidad" className="text-gray-300 hover:text-white">Política de privacidad</Link>
              </li>
              <li>
                <Link to="/terminos-y-condiciones" className="text-gray-300 hover:text-white">Términos y condiciones</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-400">
          <p>© {new Date().getFullYear()} Salient. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
